import React, { useState } from 'react'
import './Testimonial.css'
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { TestimonialCard } from '../../Components/Card/FeatureCard'
import TestimonialsList from '../../Data/Testimonial'
import { LeftRoundButton, RightRoundButton } from '../../Components/Button/RoundButton';
import { Navigation } from 'swiper/modules';
import SectionIds from '../../Helper/SectionId';
import AssetImage from '../../Helper/AssetImage';
import AssetImages from '../../Helper/AssetImages';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';


export default function Testimonial() {
  const [activeCardIndex] = useState(0);
  return (
    <SectionWithAnalytics className='section section-testimonial ' id={SectionIds.sectionTestimonials}>
      <div className='top-section'>

        <div className="header container-vertical res-gap-8 align-right">
          <div className='fs-medium fw-semibold clr-primary text-align-right '>
            Testimonials
          </div>
          <h3 className='text-align-right'>
            What <mark>Clients</mark> Say
          </h3>
        </div>

        <Swiper

          className="testimonial-swiper"
          loop={true}
          navigation={
            {
              prevEl: '.testimonial-left-btn',
              nextEl: '.testimonial-right-btn'
            }
          }
          modules={[Navigation]}
        >
          {
            TestimonialsList.map((element, index) => {
              return <SwiperSlide key={index}>
                <TestimonialCard testimonial={element} isActive={activeCardIndex === index} />
              </SwiperSlide> 
            })
          }

        </Swiper>

        <div className='testimonials-nav-btns container-horizontal res-gap-16'>
          <LeftRoundButton className='testimonial-left-btn' />
          <RightRoundButton className='testimonial-right-btn' />
        </div>
      </div>
      <div className='bottom-section'>
        <AssetImage assetImage={AssetImages.illustrationTestimonials} />
      </div>


    </SectionWithAnalytics>
  )
}

